//initialise popup form
document.addEventListener("DOMContentLoaded", () => {
  const formWrapper = ".contact-form__wrapper";
  const buttons = [".button--bulk-order", ".form__close-btn"];
  const body = "body";
  if (buttons.some((selector) => document.querySelector(selector))) {
    new PopupForm(formWrapper, buttons.join(", "), body);
  }

  const customFormWrapper = ".custom-form__wrapper";
  const buttonsCustom = [".button--custom-order", ".customForm__close-btn"];
  const customBody = "body";
  if (buttonsCustom.some((selector) => document.querySelector(selector))) {
    new PopupForm(customFormWrapper, buttonsCustom.join(", "), customBody);
  }
});
